<template>
  <div class="container">
    <ca-row>
      <ca-col v-if="showLoading">
        <ca-loader></ca-loader>
      </ca-col>

      <ca-col v-else>
        <ca-slimbox size="large">
          <ca-row>
            <ca-col>
              <ca-heading
                text="Você está prestes a acessar a Folha da Conta Azul Mais"
                size="medium"></ca-heading>
            </ca-col>
          </ca-row>

          <ca-row class="ca-u-text-center" vertical-offset="4">
            <ca-col size="4">
              <ca-illustration name="status-approved" width="45"></ca-illustration>
            </ca-col>
            <ca-col size="4">
              <ca-illustration name="balloon_warning" width="45"></ca-illustration>
            </ca-col>
            <ca-col size="4">
              <ca-illustration name="balloon_info" width="45"></ca-illustration>
            </ca-col>
          </ca-row>

          <ca-row>
            <ca-col size="4">
              <ca-row>
                <ca-col class="ca-u-text-center">
                  <ca-heading size="small" text="Indicamos este recurso para">
                  </ca-heading>
                </ca-col>
              </ca-row>

              <ca-row>
                <ca-col>
                  <ca-list theme="bullet-point" class="ca-u-margin-top">
                    <ca-list-item>
                      As empresas de
                      <b>todos os segmentos e regimes de tributação;</b>
                    </ca-list-item>
                    <ca-list-item>
                      Os clientes que desejem fazer o fechamento da
                      <b>folha integrada com as rotinas financeiras e contábeis -
                      </b>este recurso é <u>opcional</u>;
                    </ca-list-item>
                  </ca-list>
                </ca-col>
              </ca-row>
            </ca-col>

            <ca-col size="4">
              <ca-row>
                <ca-col class="ca-u-text-center">
                  <ca-heading size="small" text="O que está por vir">
                  </ca-heading>
                </ca-col>
              </ca-row>

              <ca-row>
                <ca-col>
                  <ca-list theme="bullet-point" class="ca-u-margin-top">
                    <ca-list-item>
                      Provisões de <b>férias e 13º salário;</b>
                    </ca-list-item>
                    <ca-list-item>
                      Cálculo de recisão e lançamentos para <b>Estagiários;</b>
                    </ca-list-item>
                    <ca-list-item>
                      Controle de <b>saldo de compensação de INSS</b> para empresas optantes
                      pelo Simples Nacional que ainda não estão no eSocial;
                    </ca-list-item>
                    <ca-list-item>
                      O DARF do <b>PIS/PASEP sobre a folha</b> de entidades sem fins lucrativos;
                    </ca-list-item>
                  </ca-list>
                </ca-col>
              </ca-row>
            </ca-col>

            <ca-col size="4">
              <ca-row>
                <ca-col class="ca-u-text-center">
                  <ca-heading size="small" text="O que o seu cliente ganha">
                  </ca-heading>
                </ca-col>
              </ca-row>

              <ca-row>
                <ca-col>
                  <ca-list theme="bullet-point" class="ca-u-margin-top">
                    <ca-list-item>
                      <b>Área exclusiva de visualização</b>
                      para acompanhar os <b>resultados</b>
                      dos processos de folha que você faz;
                    </ca-list-item>
                    <ca-list-item>
                      <b>Possibilidade de baixar as guias</b>
                      IRRF e INSS e <b>recibos</b> dos pagamentos;
                    </ca-list-item>
                  </ca-list>
                </ca-col>
              </ca-row>
            </ca-col>
          </ca-row>

          <ca-row vertical-offset="4" class="ca-u-margin-bottom">
            <ca-col>
              <ca-checkbox
                v-model="accept"
                label="Estou ciente das informações acima e gostaria de
                fazer uso do recurso Folha da Conta Azul para este cliente.">
              </ca-checkbox>
            </ca-col>
          </ca-row>

          <ca-footer>
            <ca-row>
              <ca-col size="3">
                <ca-button full-width @click="goBack">
                  Decidir depois
                </ca-button>
              </ca-col>
              <ca-col offset="6" size="3">
                <ca-request-button
                  theme="primary"
                  :disabled="!accept"
                  :on-request="onRequest"
                  :on-request-success="onRequestSuccess"
                  :on-request-error="onRequestError">
                  Continuar
                </ca-request-button>
              </ca-col>
            </ca-row>
          </ca-footer>
        </ca-slimbox>
      </ca-col>
    </ca-row>
  </div>
</template>

<script>
import { OK, NOT_FOUND } from 'http-status-codes';
import WorkingOnDetailsModal from './modals/WorkingOnDetailsModal';
import { checkActivation, sendActivation, enterApp } from './activationService';

export default {
  name: 'NewCompanyPage',
  data() {
    return {
      accept: false,
      showLoading: true,
    };
  },
  created() {
    this.initialCheck();
  },
  methods: {
    async initialCheck() {
      try {
        const { status } = await checkActivation();

        if (status === OK) {
          enterApp();
        }
      } catch ({ response }) {
        if (response.status !== NOT_FOUND) {
          this.$router.push({ name: 'ActivationWaiting' });
        }
      } finally {
        this.showLoading = false;
      }
    },
    onWorkingOnDetails() {
      this.$dialogModal(WorkingOnDetailsModal).open();
    },
    onRequest() {
      return sendActivation();
    },
    onRequestSuccess() {
      enterApp();
      this.$toaster.success('Ativação requisitada com sucesso!');
    },
    onRequestError() {
      this.$router.push({ name: 'ActivationWaiting' });
    },
    goBack() {
      window.location.assign(process.env.VUE_APP_ACC_WEBAPP);
    },
  },
};
</script>

<style scoped>
::v-deep .ca-checkbox-container label {
  font-weight: bold;
}
</style>
